import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { Global } from '../../../../../app.global';
import { Constants } from '../../../helper/constants';
import { ReportsService } from '../../../services/reports.service';
import { OffenceTypeViewModel } from '../../../viewmodels/offence-type-viewmodel';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'contraventions-question',
  templateUrl: './contraventions-question.component.html',
})
export class ContraventionsQuestionComponent implements OnInit, OnChanges {
  @Input() valuesSelected: Array<any> = [];
  @Input() active = true;
  @Input() options: Array<any> = [];
  @Output() selectAnswer: EventEmitter<any> = new EventEmitter<any>();

  selectedContraventionsIdsList = [];
  selectedContraventionsValuesList = [];
  contraventions: Array<OffenceTypeViewModel> = [];
  allContraventionsValue = 'n';

  constants = Constants;

  constructor(public global: Global, private reportsService: ReportsService) {}

  ngOnInit() {
    this.getContraventions();
    this.setSelectedConstraventionsLists();
  }

  ngOnChanges() {
    this.setSelectedConstraventionsLists();
  }

  setSelectedConstraventionsLists() {
    this.selectedContraventionsIdsList = [];
    this.selectedContraventionsValuesList = [];
    this.valuesSelected.forEach((selectedContravention) => {
      this.selectedContraventionsIdsList.push(selectedContravention.id);
      this.selectedContraventionsValuesList.push(selectedContravention.value);
    });
  }

  getContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventions = result;
      // const contraventionsNamesArray = [];
      // this.global.offencesTypes.forEach(offence => {
      //   contraventionsNamesArray.push(offence.name);
      // });
      // this.contraventions.forEach((contravention, index) => {
      //   contravention.name = contraventionsNamesArray[index];
      // });
    });
  }

  onAnswerSelected(value, contraventionId) {
    if (!this.active) {
      return;
    }
    this.updateSelectedValues(value, contraventionId);
    this.selectAnswer.emit(this.valuesSelected);
  }

  updateSelectedValues(value, contraventionId) {
    const index = this.selectedContraventionsIdsList.indexOf(contraventionId.id);
    this.valuesSelected[index].value = value;
  }

  isContraventionValueSelected(contraventionId, optionValue) {
    let optionValueSelected = 'n';
    const index = this.selectedContraventionsIdsList.indexOf(contraventionId.id);
    if (index > -1) {
      optionValueSelected = this.selectedContraventionsValuesList[index];
    }
    if (optionValue === optionValueSelected) {
      return true;
    }
    return false;
  }

  updateAllContraventions() {
    if (!this.active) {
      return;
    }
    this.valuesSelected.forEach((valueSelected) => {
      valueSelected.value = this.allContraventionsValue;
    });
    this.selectAnswer.emit(this.valuesSelected);
  }
}
